/**
 * Bandă de avertizare afișată cât timp userul nu are frază de recuperare.
 * Fără ea, pierderea parolei master înseamnă pierderea definitivă a datelor —
 * de aceea nu poate fi închisă, doar rezolvată.
 */
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { authApi } from '@/api/auth';

export default function RecoveryReminder() {
  const { t } = useTranslation();
  const location = useLocation();
  const status = useQuery({
    queryKey: ['recovery-status'],
    queryFn: () => authApi.recoveryStatus(),
    staleTime: 5 * 60_000,
  });

  if (!status.data || status.data.enabled || location.pathname === '/account') return null;

  return (
    <div
      role="status"
      data-testid="recovery-reminder"
      className="px-4 py-2 text-xs flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-[var(--border)]"
      style={{ background: 'var(--bg-amber, rgba(217, 119, 6, 0.12))', color: 'var(--text)' }}
    >
      <span>{t('recovery.reminder')}</span>
      <Link to="/account" className="font-medium hover:underline" style={{ color: 'var(--accent)' }}>
        {t('recovery.reminder_action')}
      </Link>
    </div>
  );
}
